import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getFuelStationGuns(companyId, fuelStationId, cashedPayload) {
  return dataTransferWrap(
    ModulesMap.FUEL_STATION_GUNS,dtConfig[ModulesMap.FUEL_STATION_GUNS].getFuelStationGuns,
    {
      urlParams: {
        companyId,
        fuelStationId,
      },
    },
    cashedPayload
  )
}

function getFuelStationGun(companyId, fuelStationId, gunId) {
  return dataTransferWrap(ModulesMap.FUEL_STATION_GUNS,dtConfig[ModulesMap.FUEL_STATION_GUNS].getFuelStationGun, {
    urlParams: {
      companyId,
      fuelStationId,
      gunId,
    },
  })
}

function getFuelStationGunPreview(companyId, fuelStationId, gunId) {
  return dataTransferWrap(ModulesMap.FUEL_STATION_GUNS,dtConfig[ModulesMap.FUEL_STATION_GUNS].getFuelStationGunPreview, {
    urlParams: {
      companyId,
      fuelStationId,
      gunId,
    },
  })
}

function getFuelStationGunPopup(companyId, fuelStationId, gunId) {
  return dataTransferWrap(ModulesMap.FUEL_STATION_GUNS,dtConfig[ModulesMap.FUEL_STATION_GUNS].getFuelStationGunPopup, {
    urlParams: {
      companyId,
      fuelStationId,
      gunId,
    },
  })
}

function postFuelStationGun(companyId, fuelStationId, data) {
  return dataTransferWrap(ModulesMap.FUEL_STATION_GUNS,dtConfig[ModulesMap.FUEL_STATION_GUNS].postFuelStationGun, {
    urlParams: {
      companyId,
      fuelStationId,
    },
    ...data,
  })
}

function patchFuelStationGun(companyId, fuelStationId, gunId, data) {
  return dataTransferWrap(ModulesMap.FUEL_STATION_GUNS,dtConfig[ModulesMap.FUEL_STATION_GUNS].patchFuelStationGun, {
    urlParams: {
      companyId,
      fuelStationId,
      gunId,
    },
    ...data,
  })
}

function putFuelStationGun(companyId, fuelStationId, gunId, data) {
  return dataTransferWrap(ModulesMap.FUEL_STATION_GUNS,dtConfig[ModulesMap.FUEL_STATION_GUNS].putFuelStationGun, {
    urlParams: {
      companyId,
      fuelStationId,
      gunId,
    },
    ...data,
  })
}

function deleteFuelStationGun(companyId, fuelStationId, gunId) {
  return dataTransferWrap(ModulesMap.FUEL_STATION_GUNS,dtConfig[ModulesMap.FUEL_STATION_GUNS].deleteFuelStationGun, {
    urlParams: {
      companyId,
      fuelStationId,
      gunId,
    },
  })
}

export default {
  getFuelStationGuns,
  getFuelStationGun,
  getFuelStationGunPreview,
  getFuelStationGunPopup,
  postFuelStationGun,
  patchFuelStationGun,
  putFuelStationGun,
  deleteFuelStationGun
}